// extracted by mini-css-extract-plugin
export var divider = "_oi-0";
export var systemMessage = "_oi-1";
export var systemMessageWrapper = "_oi-2";